/**
 * Shared SEO page chrome: top nav + footer.
 *
 * Visual language matches the rest of the site — same orange brand colour,
 * same font stack, same component scale. Booking CTAs link to existing
 * functional pages (/, /booking) — we do NOT introduce new booking logic.
 */
import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

export function SeoNav() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200" data-testid="seo-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2" data-testid="seo-nav-logo">
            <Truck className="h-6 w-6 text-orange-500" />
            <span className="font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>
              Transport Anything 247
            </span>
          </Link>
          <div className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-700">
            <Link to="/#calculator" className="hover:text-orange-500" data-testid="seo-nav-quote">Get Quote</Link>
            <Link to="/#services" className="hover:text-orange-500" data-testid="seo-nav-services">Services</Link>
            <Link to="/support" className="hover:text-orange-500" data-testid="seo-nav-support">Support</Link>
            <Link to="/blog" className="hover:text-orange-500" data-testid="seo-nav-blog">Blog</Link>
          </div>
          <a href="tel:+447757133163" className="hidden sm:inline-flex items-center gap-2 text-orange-500 font-semibold text-sm" data-testid="seo-nav-call">
            +44 7757 133163
          </a>
        </div>
      </div>
    </nav>
  );
}

export function SeoFooter() {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12 mt-16" data-testid="seo-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Truck className="h-6 w-6 text-orange-500" />
            <span className="font-bold text-white text-lg" style={{ fontFamily: "var(--font-heading)" }}>
              Transport Anything 247
            </span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Professional transport services across the UK. From parcels to heavy machinery, we move it all with dedicated, fully-insured transport.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-orange-400">Home</Link></li>
            <li><Link to="/#calculator" className="hover:text-orange-400">Get a Quote</Link></li>
            <li><Link to="/support" className="hover:text-orange-400">Support</Link></li>
            <li><Link to="/blog" className="hover:text-orange-400">Blog</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-orange-400">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-orange-400">Terms of Service</Link></li>
            <li><Link to="/cookies" className="hover:text-orange-400">Cookie Policy</Link></li>
            <li><Link to="/aup" className="hover:text-orange-400">Acceptable Use</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 pt-8 border-t border-slate-800 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Transport Anything 247. All rights reserved.
      </div>
    </footer>
  );
}
